import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { EDITOR_CONFIG } from "../../constants";
import { FileIcon } from "@shopify/polaris-icons";
import JoditEditor from "jodit-react";

const AddEditSubstudio = (props) => {
  const navigate = useNavigate();
  const { id, studioId, substudioId } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const imageKey = useRef("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [item, setItem] = useState({
    subtitle: "",
    title: "",
    description: "",
    image: "",
    isActive: true,
  });
  const editor = useRef(null);
  const handleChangeTitle = (newValue) => {
    setItem({ ...item, title: newValue });
    setTitleError("");
  };
  const [titleError, setTitleError] = useState("");
  const handleChangeSubtitle = (newValue) => {
    setItem({ ...item, subtitle: newValue });
  };
  const handleChangeDescription = (newValue) => {
    setItem({ ...item, description: newValue });
  };

  const handleChangeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };

  const [files, setFiles] = useState([]);
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );
  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
  const fileUpload = !files.length && <DropZone.FileUpload />;
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      {files.map((file, index) => (
        <div key={index} className="rowDiv">
          <Thumbnail
            size="small"
            alt={file.title}
            source={
              validImageTypes.includes(file.type)
                ? window.URL.createObjectURL(file)
                : NoteIcon
            }
          />
          <div>
            {file.title}{" "}
            <Text variant="bodySm" as="p">
              {file.size} bytes
            </Text>
          </div>
        </div>
      ))}
    </div>
  );
  const sendImage = (files) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity", "studio");
    form_data.append("image", files[files.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data;
        setIsImageUploading(false);
        setItem({
          ...item,
          image:
            validImageTypes.indexOf(files[files.length - 1].type) > 0
              ? window.URL.createObjectURL(files[files.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };

  const [imageError, setImageError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  useEffect(() => {
    props.type === "edit" &&
      axios
        .get(`/elements/${id}/studios/${studioId}/sub-studios/${substudioId}`)
        .then((result) => {
          setItem({
            title: result?.data?.data?.name ? result.data.data.name : "",
            subtitle: result?.data?.data?.subtitle
              ? result.data.data.subtitle
              : "",
            description: result?.data?.data?.description
              ? result.data.data.description
              : "",

            image: result?.data?.data?.image ? result?.data?.data?.image : "",
            isActive: result?.data?.data?.is_active ? true : false,
          });
          setIsSaving(false);
        })

        .catch((err) => console.log(err));
  }, []);
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Studio`}
      backAction={{
        onAction: () =>
          navigate(`/admin/elements/${id}/categories/${studioId}/studios`),
      }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <FormLayout.Group>
            <TextField
              value={item.title}
              onChange={handleChangeTitle}
              label="Name"
              error={titleError}
            />
            <TextField
              value={item.subtitle}
              onChange={handleChangeSubtitle}
              label="Subtitle"
            />
          </FormLayout.Group>

          <Text>Description </Text>
          <JoditEditor
            ref={editor}
            value={item.description}
            config={EDITOR_CONFIG}
            onBlur={handleChangeDescription}
          />
          <Text>Image</Text>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail size="large" source={item.image ? item.image : ""} />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                onDrop={handleDropZoneDrop}
                allowMultiple={false}
                onDropAccepted={sendImage}
              >
                {uploadedFiles}
                {fileUpload}
              </DropZone>
            </div>
          </div>

          <Checkbox
            label="Is active"
            checked={item.isActive}
            onChange={handleChangeActive}
          />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => {
                setIsSaving(true);
                axios
                  .delete(
                    `/elements/${id}/studios/${studioId}/sub-studios/${substudioId}`
                  )
                  .then((result) => {
                    navigate(
                      `/admin/elements/${id}/categories/${studioId}/studios`
                    );
                  })
                  .catch((err) => console.log(err));
              }}
            >
              Delete
            </Button>
          )
        }
      />
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if (!item.title) {
      !item.title && setTitleError("This field is required");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      // form_data.append("element_id", id);
      // form_data.append("parent_id", studioId);
      item.title && form_data.append("name", item.title);
      item.subtitle && form_data.append("subtitle", item.subtitle);
      item.description && form_data.append("description", item.description);
      imageKey.current && form_data.append("image", imageKey.current);
      form_data.append("is_active", item.isActive ? 1 : 0);
      props.type === "edit" && form_data.append("_method", "PATCH");

      props.type === "add"
        ? axios
            .post(`/elements/${id}/studios/${studioId}/sub-studios`, form_data)
            .then((result) => {
              navigate(`/admin/elements/${id}/categories/${studioId}/studios`);
            })
            .catch((err) => console.log(err))
        : axios
            .post(
              `/elements/${id}/studios/${studioId}/sub-studios/${substudioId}`,
              form_data
            )
            .then((result) => {
              toggleActive();
              setIsSaving(false);
            })
            .catch((err) => console.log(err));
    }
  }
};

export default AddEditSubstudio;
